export const BOCHK = ["Assisted customers with daily transactions.",
    "Assisted customer managers in identifying high-quality clients for appropriate referral.",
    "Achieved interpersonal ladder target in September 2023, nominated for recommendation and completed Relationship Management Assistant training.",
    "Became a licensed agent in September 2023 (able to conduct securities transactions under Bank of China Hong Kong's internal guidelines).",
    "Handled account opening procedures for clients.",
    "Promoted suitable bank products and referred clients to sales staff (non-sales role)."]

export const Beulah = ["Prepared customs clearance export trade documents",
    "Recorded sales and procurement details",
    "Arranged sales and procurement logistics",
    "Issued invoices",
    "Responded to customer enquiries",
    "Accompanied clients in procurement and created marketing opportunities.",
    "Prepared annual financial statement for auditing purposes.",
    "Real-time integration of sales and procurement records for manager or director review"
]

export const DBS = [
    "Provide one-stop service to respond product and service enquiries that customers are experiencing by phone, live chat , offline messaging and emails",
    "Drive a successful customer experience by assisting at varied skill levels (from offline to online) to implement inbound cross-buy initiatives proactively",
    "Meet individual scorecard for call volume, availability, service level and customer satisfaction",
    "Attract and retain customers by answering queries and providing suggestions that lead to short and long-term success",
    "Work collaboratively with teammates to solve customer issues as quicky and as efficiently as possible",
    "Report customer complaints and escalate issues when necessary to prevent potential churn"
]

export const Tutornotes = [
    "Leased and operated study groups in Nan Fung Centre and Tsuen Fai Commercial Building",
    "Developed a YouTube tutorial channel and website for AdSense profit and promotional goals",
    "Acheivement: Reached 2k subscribers with organic traffic which acheive a high degree of success in cost effective promotion"
]


export const CTBC = [
    "Handle customers' enquires via phone calls and emails including addressing problems with electronic banking and follow up on the transaction;",
    "Ensure the application forms submitted by customers are duly completed and delivered to relevant departments promptly;",
    "Follow up on VIP clients’ transaction requests until transactions are completed;",
    "Handle ad-hoc projects as assigned by Management."
]